import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSF Terminals API
 */
export const wsfTerminalsApiMeta: ApiMeta = {
  name: "wsf-terminals",
  baseUrl: "https://www.wsdot.wa.gov/ferries/api/terminals/rest",
};
